<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <!-- 탭으로 관리 -->
        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger">
          <b-tab title="User">
            <List-User ref="user_list" />
          </b-tab>
          <b-tab title="Partner">
            <List-partner ref="admin_list" />
          </b-tab>
          <b-tab title="Admin">
            <List-Admin ref="partner_list" />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ListUser from './Auth.List.User';
import ListAdmin from './Auth.List.Admin';
import ListPartner from './Auth.List.Partner';

export default {
  name : "authList",
  props: ['user', 'auto_refresh'],
  components: { ListUser, ListAdmin, ListPartner, },
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  created() { console.log('log.auth.vue', 'created'); },
  destroyed() { console.log('log.auth.vue', 'destroyed'); },
  mounted() {
    console.log('log.auth.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    if(this.user) {
      this.so.sk = 'addr'
      this.so.skt = 'Address'
    }
  },
}
</script>
